import { css } from '@emotion/css';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { RootState } from 'src/features';
import { actions } from 'src/features/resort';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { sendEvent } from 'src/lib/google-analytics';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';
import { FollowButton } from '../common/FollowButton';
import { ResortUserInfo } from './ResortUserInfo';

interface ResortPromotionUserProps {
  profile: UserResortProfile;
  isFollowing: boolean;
}

export const ResortPromotionUser: React.FC<ResortPromotionUserProps> = ({
  profile,
  isFollowing
}) => {
  const { followStatus } = useSelector((state: RootState) => state.resort);
  const dispatch = useDispatch();
  const history = useHistory();
  const routeMatch = useRouteMatch();
  const baseUrl = routeMatch?.url;

  const userColor = getResortUserColor(profile.resortPlannerPromotionColor);

  useEffect(() => {
    if (baseUrl) {
      switch (followStatus?.state) {
        case 'ok':
          if (isFollowing) {
            history.push(`${baseUrl}/follow-succeeded`);
          } else {
            history.push(`${baseUrl}/unfollow-succeeded`);
          }
          break;
        case 'error':
          if (isFollowing) {
            history.push(`${baseUrl}/unfollow-failed?error=${followStatus.error}`);
          } else {
            history.push(`${baseUrl}/follow-failed?error=${followStatus.error}`);
          }
      }
    }
    // isFollowingの状態はfollowStatusが変わる時以外でも変化する可能性があるため、第2引数に含めない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl, followStatus, history]);

  useEffect(() => {
    return () => {
      dispatch(actions.resetFollowStatus());
    };
  }, [dispatch]);

  const handleMenuClick = useCallback(() => {
    if (baseUrl) {
      history.push(`${baseUrl}/menu`);
    }
  }, [baseUrl, history]);

  const handleFollowButtonClick = useCallback(() => {
    if (isFollowing) {
      sendEvent('resort_unfollow_player', 'click');
      dispatch(actions.unfollowUser(profile.resortPlannerId));
    } else {
      sendEvent('resort_follow_player', 'click');
      dispatch(actions.followUser(profile));
    }
  }, [dispatch, isFollowing, profile]);
  return (
    <div
      className={css`
        .follow-button {
          margin-top: 16px;
        }
      `}
    >
      <ResortUserInfo
        name={profile.name}
        image={profile.image}
        isMyself={false}
        resortPlannerGrade={profile.resortPlannerGrade}
        resortPlannerId={profile.resortPlannerId}
        isReported={profile.screening === 'ng'}
        isFollowing={isFollowing}
        onMenuClick={handleMenuClick}
      />

      <div className="follow-button">
        <FollowButton
          isFollowing={isFollowing}
          isLoading={followStatus?.state === 'pending'}
          onClick={handleFollowButtonClick}
          userColor={userColor}
        />
      </div>
    </div>
  );
};
